/**
 * Helpers to extract MCP tool response text from a step / stepDetails pair.
 * Tool results land in different shapes depending on the source flow
 * (AI Generate via testReplayAgent vs Replay via WebSocket), so we hunt a
 * known list of candidate paths and return the first non-empty text.
 */

export function coerceMcpContentToText(value) {
    if (value == null) return null;
    if (typeof value === 'string') return value;
    if (Array.isArray(value)) {
        const parts = value
            .map((item) => {
                if (item == null) return null;
                if (typeof item === 'string') return item;
                if (typeof item === 'object' && typeof item.text === 'string') return item.text;
                return null;
            })
            .filter(Boolean);
        return parts.length ? parts.join('\n') : null;
    }
    if (typeof value === 'object' && typeof value.text === 'string') return value.text;
    return null;
}

export function extractToolResponseText(step, stepDetails) {
    const mainAction = step?.executionGroup?.mainAction;
    const candidates = [
        // AI Generate flow: executionTracker wraps result as { success, preview }
        step?.result?.preview,
        mainAction?.result?.preview,
        // AI Generate flow: raw MCP content on step
        step?.result?.content,
        mainAction?.result?.content,
        // AI Generate flow: details.resultText
        step?.details?.resultText,
        mainAction?.details?.resultText,
        // Replay flow: toolCallTrace.response paths
        stepDetails?.result?.toolCallTrace?.response,
        stepDetails?.toolCallTrace?.response,
        stepDetails?.result?.result?.toolCallTrace?.response,
        // Replay flow: raw MCP content paths
        stepDetails?.result?.result?.content,
        stepDetails?.result?.content,
        stepDetails?.result?.result?.text,
        stepDetails?.result?.text,
    ];
    for (const c of candidates) {
        const text = coerceMcpContentToText(c);
        if (text) return text;
    }
    return null;
}
